import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';


export const NoResultsCard = () => {
    return (
        <Card className="fundingSourcesCard">
            <CardBody>
                <Row>
                    <Col className="fundingSourcesNoResults">
                        <p><strong>We're sorry, but we found no matching results.</strong> Please try using less specific terms or fewer filters.</p>
                        <p>Don't forget, <Link className="accent-link" to="/ContactUs" target="_self">you can contact us</Link> for a free, full fleet assessment to determine which funding sources your fleet is eligible for.</p>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}